export default __webpack_public_path__ + "static/media/close_tag.2eab4d46.svg";